export const formatBlogPosts = (blogs: any) => {
    return blogs.map((blog:any) => {
      const {content} = blog
      return {
        _id: blog.uuid,
        slug: blog.slug,
        title: content.title,
        author: content.author,
        image: {
          url: content.thumbnail.filename,
          alt: content.thumbnail.alt
        },
        content: content.content,
        tags: blog.tag_list,
        created_at:blog.created_at,
        thumbnailSnippet:content.thumbnailSnippet
      }
    })
  }